import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { api } from './utils/api';
import './styles/common.css';
import './styles/index.css';
import './styles/sale.css';

function Carousel() {
    const [campaigns, setCampaigns] = useState([]);
    const [activeCampaignIndex, setActiveCampaignIndex] = useState(0);
    const intervalRef = useRef();
    useEffect(() => {
        api.getCampaigns().then((json) => {
            setCampaigns(json.data);
            intervalRef.current = window.setInterval(() => {
                setActiveCampaignIndex((prev) => (prev === json.data.length - 1 ? 0 : prev + 1));
            }, 5000);
        });
    }, []);
    return (
        <div className="carousel">
            {campaigns.map((campaign, index) => (
                <Link
                    className={`carousel__campaign${index === activeCampaignIndex ? ' carousel__campaign--active' : ''}`}
                    style={{
                        backgroundImage: `url(${campaign.picture})`,
                    }}
                    key={campaign.id}
                    to={`../product?id=${campaign.product_id}`}
                >
                    <div className="carousel__campaign-story">
                        <div className="carousel__campaign-story-content">{campaign.story.split('\r\n').slice(0, 3).join('\r\n')}</div>
                        <div className="carousel__campaign-story-title">{campaign.story.split('\r\n')[3]}</div>
                    </div>
                </Link>
            ))}
            <div className="carousel__dots">
                {campaigns.map((campaign, index) => (
                    <div
                        className={`carousel__dot${index === activeCampaignIndex ? ' carousel__dot--active' : ''}`}
                        key={campaign.id}
                        onClick={() => {
                            setActiveCampaignIndex(index);
                            window.clearInterval(intervalRef.current);
                            intervalRef.current = window.setInterval(() => {
                                setActiveCampaignIndex((prev) => (prev === campaigns.length - 1 ? 0 : prev + 1));
                            }, 5000);
                        }}
                    />
                ))}
            </div>
        </div>
    );
}

function SaleSection() {
    const [cartItems] = useState(JSON.parse(window.localStorage.getItem('cart')) || []);
    // const [cartSaleItems] = useState(cartItems.filter(i => i));
    // 目前全部購物車都顯示在頁面圖片容器內
    // 當爬蟲產品可加入購物車後，調整為以下程式碼，使user可在促銷頁面促銷累計件數
    const [cartSaleItems] = useState(cartItems.filter(i => i.on_sale === 1));
    const cartSaleItemsLength = cartSaleItems ? cartSaleItems.reduce((prev, item) => prev + item.qty, 0) : 0;
    let explodeCartSaleItems = []

    if (cartSaleItems){
        cartSaleItems.forEach((n) => {
        // explodeCartSaleItems.push(explodeList);
        Array(n.qty).fill(0).forEach((e, i) => {
        const explodeList = {
            countId: `${n.id}_${i}`,
            id: n.id,
            qty: 1,
            image: n.image,
        };
            explodeCartSaleItems.push(explodeList);
        });
        })
    }

    useEffect(()=>{
        console.log(`購物車內共計${cartItems.reduce((prev, item) => prev + item.qty, 0)}個商品，其中含促銷商品${cartSaleItems.reduce((prev, item) => prev + item.qty, 0)}個`);
    },[cartItems])

    return (
        <div className='sale'>
            <div className='sale--title'>您已選擇
                <span className='sale--title--selected'>{ cartSaleItemsLength }</span>件，再選購
                <span className='sale--title--need'>{ cartSaleItemsLength > 5 ? 0 : 5 - cartSaleItemsLength }</span>件可獲得500元折扣
            </div>
            <div className='sale--container'>
                { explodeCartSaleItems.slice(0,5).map((item, index) => 
                    <div className='sale--container--block' key={ index }><img src={ item.image } alt='main_image'/></div>
                )}
                {Array( cartSaleItemsLength > 5 ? 0 : 5 - cartSaleItemsLength ).fill(0).map((_, i) => 
                    <div className='sale--container--block' key = { i }></div>
                )}
                {/* <div className='sale--container--block--counter'>+{ explodeCartSaleItems.length > 5 ? explodeCartSaleItems.length - 5 : '' } </div>  */}
            </div>
        </div>
    );
}

function Products() {
    const [products, setProducts] = useState([]);
    const [params] = useSearchParams();
    useEffect(() => {
        let nextPagingRef = 0;
        setProducts([]);
        const intersectionObserver = new IntersectionObserver(async ([entry], observer) => {
            const { intersectionRatio, target } = entry;
            if (intersectionRatio <= 0) return;

            // const q = params.get('q');
            // const category = params.get('category');

            // function fetchProducts() {
            //     if (q) {
            //         return api.searchProducts(q, nextPagingRef);
            //     }
            //     if (category) {
            //         return api.getProducts(category, nextPagingRef);
            //     }
            //     return api.getProducts('all', nextPagingRef);
            // }

            function fetchSale(){
                return fetch('https://shopxyz.online/api/1.0/products/sale').then((response) => response.json())
            }

            await fetchSale().then((json) => {
                setProducts((prev) => [...prev, ...json.data]);
                // nextPagingRef = json.next_paging;
                nextPagingRef = undefined; // 爬蟲資料目前無paging，此處使observer只在第一次載入
            });
            if (nextPagingRef === undefined) {
                observer.unobserve(target);
                return;
            }
        });
        const waypoint = document.querySelector('.waypoint');
        intersectionObserver.observe(waypoint);
        return () => intersectionObserver.unobserve(waypoint);
    }, [params]);
    return (
        <React.Fragment>
            <div className="products">
                {products.map((product) => (
                    <Link className="product-index" key={product.id} to={`../product?id=${product.id}`}>
                        <img src={product.main_image} className="product__image" alt="product" />
                        <div className="product__colors">
                            {product.colors.slice(0, 4).map((color) => (
                                <div
                                    className="product__color"
                                    style={{
                                        backgroundColor: `#${color.code}`,
                                    }}
                                    key={color.code}
                                />
                            ))}
                        </div>
                        <div className="product__title">{product.title}</div>
                        <div className="product-index__price">TWD.{product.price}</div>
                    </Link>
                ))}
            </div>
            <div className="waypoint" style={{ height: '100px' }}></div>
        </React.Fragment>
    );
}

export default function Sale() {
    return (
        <>
            <Carousel />
            <SaleSection />
            <Products />
        </>
    );
}
